import React from 'react';
import { useNavigate, useParams } from "react-router-dom";

const InstagramShareButton = ({ imageUrl, campaignId, reward, chances, congratsImage, tnxId, campaignType, campaignConfig, winAnimations }) => {
    const navigate = useNavigate();
    const { tenanturlname } = useParams();

    return (
        <button
            style={{ border: 'none', marginRight: '10px', backgroundColor: 'white' }}
            onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'cta_click', ctaName: 'social_share_instagram', campaignId: String(campaignId) });
                navigate(`/${tenanturlname}/gamification/sharing`, {
                    state: {
                        reward: reward,
                        chances: chances,
                        campaignId: campaignId,
                        congratsImage: congratsImage,
                        type: 'instagram',
                        imageUrl: imageUrl,
                        tnxId: tnxId,
                        campaignType: campaignType,
                        campaignConfig: campaignConfig,
                        winAnimations: winAnimations || []
                    }
                });
            }}
        >
            <img
                src={require('../../../assets/images/icons/instagram-icon.png')}
                alt="Instagram"
                onError={(e) => {
                    e.target.style.display = 'none';
                }}
            />
        </button>
    );
};

export default InstagramShareButton;
